import { isEqual, result } from 'lodash';

import APIClient from '../../../../common/services/APIClient';

import {
  listRequest,
  listRequestError,
  listRequestSuccess,
  setForceUpdate,
  setTotalCount,
} from '../../../../common/components/SSPList/actions';

import { transformQueryOut } from '../../../../common/components/AdvancedSearch/QueryBuilder/utils';
import { emptyFilter, fillChargersFilter, getConfigurationPayload, TABS } from '../../../../common/components/AdvancedSearch/utils';
import { getChargersAdvancedSearchConfig } from '../../../ChargersList/constants';
import { multiFwUpdateTableId } from '../../../MultiFwUpdate/constants';
import { setMessageListUnavailable } from '../../../../common/components/Alert/actions';
import { emptyQuery, OPERATOR_NAME } from '../../../../common/components/AdvancedSearch/QueryBuilder/constants';

export const setFwList = (fwList) => ({
  type: 'SET_FW_LIST',
  fwList,
});

export const toggleSelectAll = (id) => ({
  type: 'SSP_TOGGLE_SELECT_ALL',
  id,
});

const setError = (text) => ({
  type: 'SET_ERROR',
  text,
});

const setSelectedFwVersion = (selectedFwVersion) => ({
  type: 'SET_SELECTED_FW_VERSION',
  selectedFwVersion,
});

const toggleConfirmationDialog = (isOpen) => ({
  type: 'OPEN_CONFIRMATION_DIALOG',
  isOpen,
});

export const getPlates =
  (id, { page_token: pageToken = 0, page_size: pageSize = 10, filterQuery, filter_by: filterBy, sorting = {} }) =>
  (dispatch, getState) => {
    const {
      advancedSearch: { selectedTab },
    } = getState();

    const isConfigurationTab = selectedTab?.[id] === TABS.CONFIGURATION && !isEqual(filterQuery, emptyQuery);

    dispatch(listRequest(id));

    const filter = transformQueryOut([filterQuery], getChargersAdvancedSearchConfig())[0] || emptyFilter;

    if (filterBy) {
      fillChargersFilter(filterBy, filter);
    }

    const payload = {
      filter_by: filter || {},
    };

    if (isConfigurationTab) {
      payload.config_nodes_filter = getConfigurationPayload(filter);
      payload.filter_by = {};
    }

    APIClient.post('/firmware_updates', payload, {
      params: {
        page_token: pageToken,
        page_size: pageSize,
        sort_by: sorting.id,
        sort_order: sorting.desc ? 'DESC' : 'ASC',
      },
    })
      .then((resp) => {
        const data = result(resp, 'data.payloads', null);
        const size = result(resp, 'data.total_size', 0);
        const filteredData = data.filter((item) => !!item);

        dispatch(listRequestSuccess(id, filteredData));
        dispatch(setTotalCount(id, size));
      })
      .catch((err) => {
        if (err.response && err.response.status === 500) {
          dispatch(setMessageListUnavailable());
        }
        dispatch(listRequestError(id, err));
        console.error(err);
      });
  };

export const refreshTable = () => (dispatch) => {
  dispatch(setForceUpdate(multiFwUpdateTableId));
};

export const executeMultipleUpdate =
  ({ filterQuery, filter, sorting = {}, c_uuids: cUuids = [], firmware_version: firmwareVersion = '' }) =>
  (dispatch) => {
    if (!firmwareVersion) {
      dispatch(setError('firmware_id should not be empty'));

      return;
    }

    let filterBy = filterQuery ? transformQueryOut([filterQuery], getChargersAdvancedSearchConfig())[0] : emptyFilter;

    if (cUuids.length > 0) {
      filterBy = { operator: 'AND', conditions: [{ field: 'c_uuids', operator: OPERATOR_NAME.anyOf, value: cUuids }] };
    } else if (filter) {
      fillChargersFilter(filter, filterBy);
    }

    APIClient.put(`/chargers/control/update_firmware?firmware_version_uuid=${firmwareVersion}`, { filter_by: filterBy })
      .then(() => {
        dispatch(toggleConfirmationDialog(false));
        dispatch(refreshTable());
      })
      .catch((err) => {
        dispatch(toggleConfirmationDialog(false));
        dispatch(setError(err.message));
      });
  };

export const getFwVersions = () => (dispatch) => {
  APIClient.get('/firmwares/available')
    .then((resp) => {
      const data = result(resp, 'data', null);
      const filteredData = data.filter((item) => !!item);

      dispatch(setFwList(filteredData));
    })
    .catch((err) => {
      dispatch(setError(err.toString()));
    });
};

export const setFwVersion = (selectedFwVersion) => (dispatch) => {
  dispatch(setSelectedFwVersion(selectedFwVersion));
};

export const openDialog = () => (dispatch) => {
  dispatch(toggleConfirmationDialog(true));
};

export const onSubmitConfirmationDialog = () => (dispatch) => {
  dispatch(toggleConfirmationDialog(false));
};

export const closeConfirmationDialog = () => (dispatch) => {
  dispatch(toggleConfirmationDialog(false));
};
